import request from '@/natives/libs/request';

export default {
  // 获取所有国家升级策略
  getAllUpgradeStrategy: () => request.get('/hpp/company/hik_id/v2/country_upgrade_strategy/all'),
  login: (params) => request.post('/hpp/company/security/v1/account/login', params, { hasErrorHandle: false }),
  sendActiveAccountEmail: (params) => request.post('/hpp/company/v1/active/account/mail', params),
  emailVerifyCodeCheck: (params) => request.post('/hpp/company/v1/regist/verify/code/check', params),
  getNewVerifyCodeCheck: (params) =>
    request.post('/hpp/company/v2/regist/verify/code/mail', params, { hasErrorHandle: false }),
  resetAccountPw: (params) => request.post('/hpp/user/company/security/v2/password/reset', params),
  sendResetPWMail: (params) =>
    request.post('/hpp/company/security/v1/password/reset/code/mail', { email: params }, { hasErrorHandle: false }),
  markEmailAsEmployee: (params) => request.sendBeacon('/hpp/company/manager/v1/installer/mark/employee', params),
  checkUrlValid: (params) =>
    request.post('/hpp/company/manager/v1/installer/invitation/check', params, { hasErrorHandle: false }),
  getRsaPublicKey: () => request.post('/hpp/ccfauth/public/key/v1/secret/get', { productId: 1 }),
  // portalAutoLogin验证接口
  autoLoginAuth: () =>
    request.post('/hpp/ccfauth/public/authorize', {
      productId: 1,
      businessId: 0,
      clientSource: process.env.clientSource
    }),
  // 自动登录
  autoLogin: (params) => request.post('/hpp/company/security/v3/account/login', params),
  // azure AD登录邮箱验证
  azureADCheckEmail: (params) =>
    request.get(
      `/hpp/ccfauth/public/security/hpp/saml/login?accountType=${
        params.accountType
      }&verifyCode=${params.verifyCode ? params.verifyCode : ''}&loginClient=${params.loginClient}&mode=${
        params.mode
      }&lastSessionId=${
        params.lastSessionId ? params.lastSessionId : ''
      }${params.idpId !== undefined ? `&idpId=${params.idpId}` : ''
      }${params.account !== undefined ? `&account=${params.account}` : ''}`,
      null,
      { hasErrorHandle: false }
    ),
  // azure AD登录入口灰度
  initAzureGrayscale: (params) =>
    request.post('/hpp/ccfdic/grayscale/nologin/v1/data/get', params, { hasErrorHandle: false }),
  // azure AD登录验证码
  getAzureVerifyCode: (sessionId) =>
    request.get(`/hpp/ccfauth/public/security/saml/captcha?lastSessionId=${sessionId}`, null, {
      hasErrorHandle: false
    }),
  // 获取当前SSO配置域名
  getSSODomain: () =>
    request.get(`/hpp/ccfauth/public/security/v1/domain/config`, null, {
      hasErrorHandle: false
    }),
  // 获取CDN 切换配置域名
  getCDNUrl: () =>
    request.post(`/hpp/ccfdic/v1/nologin/dicset/get`, {
      dicSetKey: Number(process.env.clientSource) === 0 ? ["HPC.dicSet.noCdnPath.BASE_LINE", "HPC.dicSet.cdnPath.BASE_LINE", "HPC.dicSet.apiDomain.BASE_LINE"] : ["HPC.dicSet.noCdnPath.LTS_CONNECT", "HPC.dicSet.noCdnPath.LTS_CONNECT", "HPC.dicSet.apiDomain.LTS_CONNECT"]
    }, { hasErrorHandle: false })
};
